import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePOST, securePUT, withQuery } from '../utilities/FetchHelper';

class HotelHistoryService {

    searchHotelOnboardingHistorySummary(hotelCode, offset, limit) {
        let url = withQuery(URLConst.HOTEL_ONBOARDING_HISTORY_SERVICE + URLConst.PATH_HISTORY_SUMMARY, {
            limit: limit,
            offset: offset
        })
        url = url.toString().replace('{hotelCode}', hotelCode)

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
    
    getHotelOnboardingHistoryDetails(hotelOnboardingId, offset, limit) {
        let url = withQuery(URLConst.HOTEL_ONBOARDING_HISTORY_SERVICE + URLConst.PATH_HISTORY_RECORD_DETAILS, {
            limit: limit,
            offset: offset
        })
        url = url.toString().replace('{hotelOnboardingId}', hotelOnboardingId)

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new HotelHistoryService();